import React from 'react';
import KodSorgulama from './KodSorgulama';

export default function KodKontrol() {

    const selectedTitleStyle = {
        backgroundColor:'rgb(35, 156, 213)',
        marginTop:'15px'
    }

  return (
    <div>
        <div id='adaParselTitle' className="formTitleAlt" style={selectedTitleStyle}>Adres Kodu Doğrulama</div>
        <KodSorgulama />
    </div>
  )
}
